export const IDENTITY_PROVIDERS = {
  'twitter-v2': 'X',
  apple: 'Apple',
  facebook: 'Facebook',
  google: 'Google',
  twitch: 'Twitch',
  youtube: 'YouTube',
}
